module.exports = __webpack_public_path__ + "img/nahlieli_yes.e52a882c.png";